import { render, staticRenderFns } from "./OrderPlaceComment.vue?vue&type=template&id=664b2637&scoped=true"
import script from "./OrderPlaceComment.vue?vue&type=script&lang=js"
export * from "./OrderPlaceComment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664b2637",
  null
  
)

export default component.exports